import React, { lazy } from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  href?: string;
  className?: string;
  size?: 'sm' | 'md';
}
export function CTAButton({
  text,
  subtext,
  href,
  className = '',
  size = 'md'
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (!href) {
      e.preventDefault();
      const scrollToPricing = () => {
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      };
      scrollToPricing();
      // Re-scroll after lazy sections render and change page height
      setTimeout(scrollToPricing, 600);
      setTimeout(scrollToPricing, 1200);
    }
  };
  const isSmall = size === 'sm';
  const ButtonContent = <div className={`relative w-full group cta-pulse ${className}`} data-id="element-97">
      <div className={`absolute -inset-1 bg-gradient-to-r from-red-600 to-orange-500 rounded-xl ${isSmall ? 'opacity-50' : 'opacity-70'} md:group-hover:opacity-100 transition duration-200`} data-id="element-98"></div>
      <button onClick={handleClick} className={`relative w-full flex flex-col items-center justify-center bg-gradient-to-b from-red-500 to-red-700 border-b-4 border-red-900 rounded-xl shadow-2xl text-white font-black uppercase tracking-wide md:hover:from-red-400 md:hover:to-red-600 transition-all ${isSmall ? 'px-4 py-3 text-base md:text-lg' : 'px-6 py-4 text-xl md:text-2xl'}`} data-id="element-99">
        <div className="flex items-center gap-2 text-center" data-id="element-100">
          {text}
          <ArrowRightIcon className={isSmall ? 'w-5 h-5' : 'w-6 h-6'} data-id="element-101" />
        </div>
        {subtext && <span className={`font-medium text-red-100 mt-1 normal-case tracking-normal ${isSmall ? 'text-xs md:text-sm' : 'text-sm md:text-base'}`} data-id="element-102">
            {subtext}
          </span>}
      </button>
    </div>;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-103">
        {ButtonContent}
      </a>;
  }
  return ButtonContent;
}